import React, { ReactNode } from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import {
  ComponentMultiStyleConfig,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useMultiStyleConfig,
} from "@chakra-ui/react";

export type CMTabSmallListProps = {
  /**
   * タブに表示するタブ名のリスト
   */
  tabNameList?: string[];

  /**
   * タブに表示する内容(コンポーネント)のリスト
   */
  childrenList?: ReactNode[];
} & ComponentStyleProps;

/**
 * タブのリストを表示するコンポーネント
 */
export const CMTabSmallList = ({
  tabNameList,
  childrenList,
  sx,
  ...rest
}: CMTabSmallListProps) => {
  const styles = useMultiStyleConfig("CMTabSmallListStyles");

  return (
    <Tabs sx={{ ...styles, ...sx }} {...rest}>
      <TabList>
        {tabNameList?.map((tabName: string, index) => {
          return (
            <Tab
              key={String(index)}
              sx={styles.tab}
              _selected={(sx = styles.selectedTab)}
            >
              {tabName}
            </Tab>
          );
        })}
      </TabList>
      <TabPanels sx={styles.tabPanels}>
        {childrenList?.map((children: ReactNode, index: number) => {
          return (
            <TabPanel key={String(index)} sx={styles.tabPanel}>
              {children}
            </TabPanel>
          );
        })}
      </TabPanels>
    </Tabs>
  );
};

export const CMTabSmallListStyles: ComponentMultiStyleConfig = {
  parts: ["tab", "selectedTab", "tabPanels", "tabPanel"],
  baseStyle: {
    tab: {
      fontSize: "sm",
      fontWeight: "normal",
      fontColor: "red.600",
    },
    selectedTab: {
      fontWeight: "bold",
      color: "blue.600",
      borderColor: "blue.600",
    },
    tabPanels: {
      h: "100%",
    },
    tabPanel: {
      h: "100%",
    },
  },
};
